module.exports = __webpack_public_path__ + "img/3_strand_braid_splash.24aed3f6.jpg";